<template>
  <v-sheet rounded="xl" class="public-expert-card">
    <div class="d-flex align-center mb-4">
      <v-avatar size="56" color="#483CB9" class="mr-3">
        <img v-if="expert.photo_url" :src="expert.photo_url" :alt="expertName">
        <span v-else class="white--text text-subtitle-1">{{ initials(expertName) }}</span>
      </v-avatar>
      <div>
        <div class="font-weight-bold text-body-1">{{ expertName }}</div>
        <div class="text-caption grey--text">Эксперт</div>
      </div>
    </div>

    <template v-for="(service, index) in services">
      <v-divider v-if="index > 0" :key="`divider-${service.serviceType.id}`" class="my-4" />
      <div :key="service.serviceType.id" class="public-expert-card__service">
        <div class="d-flex align-center mb-3">
          <v-avatar size="40" color="#ece9fb" class="mr-3">
            <v-icon color="#483CB9" size="20">mdi-account-tie-outline</v-icon>
          </v-avatar>
          <div class="font-weight-bold public-expert-card__service-name">{{ service.serviceType.name }}</div>
        </div>
        <div class="d-flex flex-wrap public-expert-card__slots">
          <button
            v-for="option in service.slots"
            :key="`${option.availability_id}-${option.starts_at}`"
            type="button"
            class="public-expert-card__slot"
            @click="$emit('select-slot', option)"
          >
            {{ timeLabel(option) }}
          </button>
        </div>
      </div>
    </template>
  </v-sheet>
</template>

<script>
import { utcToLocalTime } from '@/common/calendarTime';

export default {
  name: 'PublicExpertCard',
  props: {
    expert: { type: Object, required: true },
    services: { type: Array, default: () => [] }, // [{ serviceType, slots }]
  },
  computed: {
    expertName() {
      return `${this.expert.first_name || ''} ${this.expert.last_name || ''}`.trim();
    },
  },
  methods: {
    initials(name) {
      return name.split(' ')
        .filter(Boolean)
        .map((part) => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase();
    },
    timeLabel(option) {
      return `${utcToLocalTime(option.starts_at)}–${utcToLocalTime(option.ends_at)}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../_tokens.scss';

.public-expert-card {
  padding: $space-6;
  box-shadow: $shadow-card;

  &__service-name {
    color: #483CB9;
    font-size: $text-lg;
  }

  &__slots {
    gap: $space-2;
  }

  &__slot {
    border: 1px solid #483CB9;
    border-radius: $radius-full;
    padding: 10px $space-4;
    background: #fff;
    color: #483CB9;
    font-size: $text-md;
    font-weight: $weight-medium;
    cursor: pointer;
    transition: background-color $transition-fast, color $transition-fast;

    &:hover {
      background: #483CB9;
      color: #fff;
    }
  }
}
</style>
